import { useQuery, useQueryClient } from '@tanstack/react-query'
import { workerKeys } from './keys'
import { getPendingWorkerInvites } from 'api/worker'

export function usePendingInvites() {
  return useQuery({
    queryKey: workerKeys.pendingInvites,
    queryFn: getPendingWorkerInvites,
  })
}

export function useInvalidatePendingInvites() {
  const queryClient = useQueryClient()
  return {
    invalidate: () =>
      queryClient.invalidateQueries({ queryKey: workerKeys.pendingInvites }),
  }
}
